<div
    [ngClass]="{
        'ai-menu': parentMenu() === null,
        floating: parentMenu() === null && floating(),
        'ai-menu-submenu': parentMenu() !== null,
    }"
    [ngStyle]="style()"
>
    @if (hasHeader()) {
        <div [ngClass]="{ 'ai-menu-header': true }">
            <ng-content select="ai-menu-header"></ng-content>
        </div>
    }

    <div class="ai-menu-content">
        <ul>
            <!-- Iterar primeiro na lista de Options, se existir -->
            <!-- FIXME Transformar em um único FOR para criar os itens do menu -->

            @for (option of menuOptions; track option.label()) {
                @let item = option.getMenuItem();

                <li
                    [ngClass]="{
                        'ai-menu-item': true,
                        'ai-menu-item-disabled': item.disabled ?? false,
                        'ai-menu-item-danger': item.danger ?? false,
                    }"
                    (click)="handleClickMenuItem($event, item)"
                    (mouseenter)="onItemMouseEnter(item, $event)"
                    (mouseleave)="onItemMouseLeave(item)"
                >
                    @if (item.children && item.children.length > 0) {
                        <ai-menu
                            [items]="item.children"
                            [parentMenu]="this"
                            [parentItem]="item"
                            [style]="style()"
                            [styleClass]="styleClass()"
                            (itemClick)="handleSubMenuClick($event)"
                        />
                    }

                    <section class="ai-menu-item-content">
                        @if (item.fontIcon) {
                            <ai-icon [fontIcon]="item.fontIcon"></ai-icon>
                        } @else {
                            @if (item.imageIcon) {
                                <ai-icon [imageIcon]="item.imageIcon"></ai-icon>
                            }
                        }

                        <span class="ai-menu-item-content-label">{{
                            item.label
                        }}</span>
                        @if (item.postLabelIcons) {
                            @for (
                                postIcon of item.postLabelIcons;
                                track $index
                            ) {
                                <img
                                    aiTooltip
                                    [src]="postIcon.source"
                                    [alt]="postIcon.tooltip"
                                    [tooltipText]="postIcon.tooltip"
                                />
                            }
                        }
                        @if (item.children && item.children.length > 0) {
                            <ai-icon [fontIcon]="'fa-solid fa-chevron-right'" />
                        }
                    </section>
                </li>
            }

            @for (item of items(); track item.label) {
                <li
                    [ngClass]="
                        (items()!.at(0) === item && hasHeader()
                            ? 'ai-menu-item ai-separator-line'
                            : 'ai-menu-item') +
                        (item.disabled ? ' ai-menu-item-disabled' : '') +
                        (item.danger ? ' ai-menu-item-danger' : '')
                    "
                    (click)="handleClickMenuItem($event, item)"
                    (mouseenter)="onItemMouseEnter(item, $event)"
                    (mouseleave)="onItemMouseLeave(item)"
                >
                    @if (item.children && item.children.length > 0) {
                        <ng-container>
                            <ai-menu
                                [items]="item.children"
                                [parentMenu]="this"
                                [parentItem]="item"
                                [style]="style()"
                                [styleClass]="styleClass()"
                                (itemClick)="handleSubMenuClick($event)"
                            />
                        </ng-container>
                    }

                    <section class="ai-menu-item-content">
                        @if (item.fontIcon) {
                            <ai-icon [fontIcon]="item.fontIcon"></ai-icon>
                        } @else {
                            @if (item.imageIcon) {
                                <ai-icon [imageIcon]="item.imageIcon"></ai-icon>
                            }
                        }

                        <span class="ai-menu-item-content-text">
                            <span class="ai-menu-item-content-label">{{
                                item.label
                            }}</span>
                            @if (item.description) {
                                <span class="ai-menu-item-content-description">{{
                                    item.description
                                }}</span>
                            }
                        </span>
                        @if (item.postLabelIcons) {
                            <div
                                style="
                                    display: flex;
                                    flex: 1;
                                    justify-content: right;
                                "
                            >
                                @for (
                                    postIcon of item.postLabelIcons;
                                    track $index
                                ) {
                                    <img
                                        aiTooltip
                                        [src]="postIcon.source"
                                        [alt]="postIcon.tooltip"
                                        [tooltipText]="postIcon.tooltip"
                                    />
                                }
                            </div>
                        }

                        @if (item.children && item.children.length > 0) {
                            <ai-icon [fontIcon]="'fa-solid fa-chevron-right'" />
                        }
                    </section>
                </li>
            }
        </ul>
    </div>
</div>
<!-- </ng-template> -->
